import { render } from "./AppSubmenu.vue?vue&type=template&id=64ae1ad7&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import "./AppSubmenu.vue?vue&type=style&index=0&id=64ae1ad7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64ae1ad7"

export default script